export const viVN: { [k: string]: string } = {
  // START TRIM MARKER
  'di-ung': 'Allergies',
  'di-ung/di-ung-thuc-an': 'Allergies/FoodAllergies',
  'di-ung/di-ung-mat-mui': 'Allergies/NoseEye',
  'di-ung/di-ung-da': 'Allergies/Skin',
  'di-ung/di-ung-dong-vat-con-trung': 'Allergies/AnimalInsect',
  'di-ung/di-ung-khac': 'Allergies/OtherAllergies',
  'benh-ve-mau': 'BloodDisorders',
  'benh-ve-mau/thieu-mau': 'BloodDisorders/Anemia',
  'benh-ve-mau/thalassemia-tan-mau-bam-sinh': 'BloodDisorders/Thalassemia',
  'benh-ve-mau/hemophilia-mau-kho-dong': 'BloodDisorders/Hemophilia',
  'benh-ve-mau/roi-loan-tieu-cau': 'BloodDisorders/PlateletDisorder',
  'benh-ve-mau/benh-bach-cau': 'BloodDisorders/WhiteBloodCell',
  'benh-ve-mau/van-de-mau-khac': 'BloodDisorders/OtherBloodDisorders',
  'benh-nao-he-than-kinh': 'BrainNS',
  'benh-nao-he-than-kinh/roi-loan-co-giat': 'BrainNS/SeizureDisorders',
  'benh-nao-he-than-kinh/sa-sut-tri-tue-alzheimer': 'BrainNS/DementiaAlzheimer',
  'benh-nao-he-than-kinh/da-xo-cung': 'BrainNS/MultipleSclerosis',
  'benh-nao-he-than-kinh/benh-parkinson': 'BrainNS/ParkinsonsDisease',
  'benh-nao-he-than-kinh/dot-quy-phinh-mach-nao': 'BrainNS/StrokeAneurysm',
  'benh-nao-he-than-kinh/dau-dau-dau-nua-dau': 'BrainNS/HeadachesMigraines',
  'benh-nao-he-than-kinh/van-de-nao-cot-song': 'BrainNS/BrainSpineDisorders',
  'benh-nao-he-than-kinh/van-de-than-kinh-ngoai-bien':
    'BrainNS/PeripheralNervousSystemDisorders',
  'benh-nao-he-than-kinh/van-de-nao-than-kinh': 'BrainNS/OtherBrainNSIssues',
  'ung-thu-ung-buou': 'Cancer',
  'ung-thu-ung-buou/ung-thu-vu': 'Cancer/BreastCancer',
  'ung-thu-ung-buou/ung-thu-phoi': 'Cancer/LungCancer',
  'ung-thu-ung-buou/ung-thu-dai-truc-trang': 'Cancer/ColorectalCancer',
  'ung-thu-ung-buou/ung-thu-da-day': 'Cancer/StomachCancer',
  'ung-thu-ung-buou/ung-thu-co-tu-cung': 'Cancer/CervicalCancer',
  'ung-thu-ung-buou/ung-thu-tuyen-tien-liet': 'Cancer/ProstateCancer',
  'ung-thu-ung-buou/ung-thu-gan': 'Cancer/LiverCancer',
  'ung-thu-ung-buou/ung-thu-da': 'Cancer/SkinCancer',
  'ung-thu-ung-buou/ung-thu-xuong': 'Cancer/BoneCancer',
  'ung-thu-ung-buou/ung-thu-bang-quang': 'Cancer/BladderCancer',
  'ung-thu-ung-buou/ung-thu-tuyen-giap': 'Cancer/ThyroidCancer',
  'ung-thu-ung-buou/ung-thu-buong-trung': 'Cancer/OvarianCancer',
  'ung-thu-ung-buou/ung-thu-mau': 'Cancer/Leukemia',
  'ung-thu-ung-buou/ung-thu-tuyen-tuy': 'Cancer/PancreaticCancer',
  'ung-thu-ung-buou/u-nao': 'Cancer/BrainTumors',
  'ung-thu-ung-buou/ung-thu-khac': 'Cancer/OtherCancers',
  'ung-thu-ung-buou/u-lympho': 'Cancer/Lymphoma',
  'ung-thu-ung-buou/ung-thu-dau-co': 'Cancer/HeadNeckCancer',
  'tieu-duong-dai-thao-duong': 'Diabetes',
  'tieu-duong-dai-thao-duong/tieu-duong-type-1': 'Diabetes/Type1',
  'tieu-duong-dai-thao-duong/tieu-duong-type-2': 'Diabetes/Type2',
  'tieu-duong-dai-thao-duong/bien-chung-tieu-duong':
    'Diabetes/DiabetesComplications',
  'benh-tieu-hoa': 'digestivehealth',
  'benh-tieu-hoa/tieu-chay': 'digestivehealth/Diarrhea',
  'benh-tieu-hoa/tao-bon': 'digestivehealth/Constipation',
  'benh-tieu-hoa/viem-da-day': 'digestivehealth/Gastritis',
  'benh-tieu-hoa/loet-da-day': 'digestivehealth/StomachUlcer',
  'benh-tieu-hoa/day-bung-o-hoi': 'digestivehealth/BloatingGas',
  'benh-tieu-hoa/viem-ruot': 'digestivehealth/InflammatroyBowelDisease',
  'benh-tieu-hoa/hoi-chung-ruot-kich-thich':
    'digestivehealth/IrritableBowelSyndrome',
  'benh-tieu-hoa/o-nong': 'digestivehealth/Heartburn',
  'benh-tieu-hoa/trao-nguoc-da-day-thuc-quan': 'digestivehealth/GERD',
  'benh-tieu-hoa/loet-da-day-ta-trang': 'digestivehealth/PepticUlcerDisease',
  'benh-tieu-hoa/cum-da-day': 'digestivehealth/StomachFlu',
  'benh-tieu-hoa/loan-khuan-o-ruot-non': 'digestivehealth/SIBO',
  'benh-tieu-hoa/soi-mat': 'digestivehealth/GallbladderDisease',
  'benh-tieu-hoa/benh-tri': 'digestivehealth/Hemorrhoids',
  'benh-tieu-hoa/viem-da-day-ruot': 'digestivehealth/Gastroenteritis',
  'benh-tieu-hoa/van-de-tieu-hoa-khac': 'digestivehealth/OtherDigestiveIssues',
  'benh-tieu-hoa/benh-gan': 'digestivehealth/LiverDiseases',
  thuoc: 'drugssupplements',
  'benh-tai-mui-hong': 'EarNoseThroat',
  'benh-tai-mui-hong/benh-ve-tai': 'EarNoseThroat/Ear',
  'benh-tai-mui-hong/benh-ve-mui': 'EarNoseThroat/Nose',
  'benh-tai-mui-hong/benh-ve-hong': 'EarNoseThroat/ThroatConditions',
  'nhan-khoa': 'eyehealth',
  'nhan-khoa/suy-giam-mat-thi-luc': 'eyehealth/VisionImpairmentLoss',
  'nhan-khoa/benh-nhan-khoa': 'eyehealth/EyeDiseases',
  'nhan-khoa/cham-soc-mat': 'eyehealth/EyeCare',
  'nhan-khoa/cuom-nuoc-glocom': 'eyehealth/Glaucoma',
  'nhan-khoa/duc-thuy-tinh-the': 'eyehealth/Cataracs',
  'nhan-khoa/cac-van-de-ve-mat-khac': 'eyehealth/OtherEyeIssues',
  'suc-khoe': 'Health',
  'suc-khoe/xet-nghiem-y-khoa': 'Health/MedicalTests',
  'suc-khoe/phau-thuat': 'Health/Surgeries',
  'suc-khoe/ban-tin-suc-khoe': 'Health/News',
  'suc-khoe/benh-vien': 'Health/Hospital',
  'suc-khoe/bao-hiem-suc-khoe': 'Health/Insurance',
  'suc-khoe/hoi-de-khoe-hon': 'Health/AskToGetBetterForSanofi',
  'suc-khoe/giam-dau': 'Health/PainManagement',
  'suc-khoe/trieu-chung': 'Health/Symptoms',
  'suc-khoe/kien-thuc-suc-khoe': 'Health/GeneralHealthKnowledge',
  'the-duc-the-thao': 'healthfitness',
  'the-duc-the-thao/cardio-suc-ben': 'healthfitness/CardioEndurance',
  'the-duc-the-thao/tang-cuong-suc-manh': 'healthfitness/StrengthTraining',
  'the-duc-the-thao/chan-thuong-the-thao': 'healthfitness/ExerciseSafetyTips',
  'the-duc-the-thao/dong-luc-tap-luyen': 'healthfitness/FitnessMotivation',
  'the-duc-the-thao/hoat-dong-the-chat-khac':
    'healthfitness/OtherFitnessActivities',
  'the-duc-the-thao/bai-tap-giam-can': 'healthfitness/WeightLossExercises',
  'the-duc-the-thao/can-bang-deo-dai': 'healthfitness/BalanceFlexibility',
  'lao-hoa-lanh-manh': 'healthyaging',
  'lao-hoa-lanh-manh/qua-trinh-lao-hoa': 'HealthyAging/ActiveAging',
  'lao-hoa-lanh-manh/nao-bo-lao-hoa': 'HealthyAging/AgingMind',
  'lao-hoa-lanh-manh/co-the-lao-hoa': 'HealthyAging/AgingBody',
  'lao-hoa-lanh-manh/dinh-duong-cho-nguoi-cao-tuoi':
    'HealthyAging/NutritionForAging',
  'lao-hoa-lanh-manh/van-de-lao-hoa': 'HealthyAging/CommonAgingConditions',
  'an-uong-lanh-manh': 'healthyeating',
  'an-uong-lanh-manh/beo-phi': 'healthyeating/Obesity',
  'an-uong-lanh-manh/cong-thuc-nau-an-tot-cho-suc-khoe':
    'healthyeating/HealthyRecipes',
  'an-uong-lanh-manh/che-do-an-kieng-va-quan-ly-can-nang':
    'healthyeating/DietWeightLoss',
  'an-uong-lanh-manh/thong-tin-dinh-duong': 'healthyeating/NutritionFacts',
  'an-uong-lanh-manh/che-do-dinh-duong-dac-biet': 'healthyeating/SpecialDiets',
  'an-uong-lanh-manh/dinh-duong-khi-tap-luyen': 'healthyeating/SportsNutrition',
  'an-uong-lanh-manh/bi-quyet-an-uong-lanh-manh':
    'healthyeating/OtherhealthyeatingTips',
  'thoi-quen-lanh-manh': 'HealthyHabits',
  'thoi-quen-lanh-manh/so-cuu-va-phong-ngua': 'HealthyHabits/FirstAid',
  'thoi-quen-lanh-manh/bo-thuoc-la': 'HealthyHabits/QuitSmoking',
  'thoi-quen-lanh-manh/ve-sinh': 'HealthyHabits/GeneralHygiene',
  'thoi-quen-lanh-manh/song-xanh': 'HealthyHabits/GreenLiving',
  'tam-ly-tam-than': 'healthymind',
  'tam-ly-tam-than/nghien': 'healthymind/Addiction',
  'tam-ly-tam-than/roi-loan-lo-au': 'healthymind/AnxietyDisorder',
  'tam-ly-tam-than/tram-cam-roi-loan-cam-xuc': 'healthymind/MoodDisorder',
  'tam-ly-tam-than/phong-ngua-tu-tu': 'healthymind/SuicidePrevention',
  'tam-ly-tam-than/quan-ly-cang-thang': 'healthymind/StressManagement',
  'tam-ly-tam-than/roi-loan-an-uong': 'healthymind/EatingDisorders',
  'tam-ly-tam-than/moi-quan-he': 'healthymind/HealthyRelationships',
  'tam-ly-tam-than/roi-loan-phat-trien': 'healthymind/Developmental Disorder',
  'tam-ly-tam-than/van-de-tam-ly-tam-than':
    'healthymind/OtherMentalHealthIssues',
  'giac-ngu': 'healthysleep',
  'giac-ngu/giac-ngu-ngon': 'healthysleep/AGoodNightsSleep',
  'giac-ngu/ngung-tho-khi-ngu': 'healthysleep/SleepApnea',
  'giac-ngu/mat-ngu': 'healthysleep/Insomnia',
  'giac-ngu/roi-loan-giac-ngu': 'healthysleep/SleepDisorders',
  'benh-tim-mach': 'HeartHealth',
  'benh-tim-mach/cao-huyet-ap-tang-huyet-ap': 'HeartHealth/Hypertension',
  'benh-tim-mach/benh-tim': 'HeartHealth/HeartDisease',
  'benh-tim-mach/tim-nhiem-trung': 'HeartHealth/HeartInfections',
  'benh-tim-mach/cholesterol': 'HeartHealth/Cholesterol',
  'benh-tim-mach/suy-tim': 'HeartHealth/HeartFailure',
  'benh-tim-mach/dong-mach-vanh': 'HeartHealth/CoronaryArteryDisease',
  'benh-tim-mach/roi-loan-nhip-tim': 'HeartHealth/HeartArrhythmias',
  'benh-tim-mach/benh-tim-bam-sinh': 'HeartHealth/CongenitalHeartDisease',
  'benh-tim-mach/van-tim': 'HeartHealth/HeartValve',
  'benh-tim-mach/xo-vua-dong-mach': 'HeartHealth/Atherosclerosis',
  'benh-tim-mach/benh-co-tim': 'HeartHealth/Cardiomyopathy',
  'benh-tim-mach/van-de-tim-mach-khac': 'HeartHealth/OtherCardiovascularIssues',
  'duoc-lieu': 'herbalalternatives',
  'duoc-lieu/thao-duoc': 'herbalalternatives/Herbal',
  'duoc-lieu/duoc-lieu-khac': 'herbalalternatives/Alternatives',
  'benh-truyen-nhiem': 'InfectiousDiseases',
  'benh-truyen-nhiem/coronavirus': 'InfectiousDiseases/Coronavirus',
  'benh-truyen-nhiem/nhiem-trung-duong-ho-hap':
    'InfectiousDiseases/RespiratoryInfections',
  'benh-truyen-nhiem/nhiem-trung-duong-an-uong':
    'InfectiousDiseases/FoodborneInfections',
  'benh-truyen-nhiem/van-de-nhiem-khuan-khac':
    'InfectiousDiseases/OtherBacterialInfections',
  'benh-truyen-nhiem/nhiem-trung-duong-khong-khi':
    'InfectiousDiseases/AirborneInfections',
  'benh-truyen-nhiem/zika': 'InfectiousDiseases/Zika',
  'benh-truyen-nhiem/sot-xuat-huyet': 'InfectiousDiseases/Dengue',
  'benh-truyen-nhiem/nhiem-trung-do-con-trung':
    'InfectiousDiseases/InfectionsFromInsects',
  'benh-truyen-nhiem/benh-truyen-nhiem-khac':
    'InfectiousDiseases/OtherViralInfections',
  'benh-truyen-nhiem/viem-mang-nao': 'InfectiousDiseases/Meningitis',
  'benh-truyen-nhiem/mun-rop': 'InfectiousDiseases/Herpes',
  'benh-truyen-nhiem/thuong-han': 'InfectiousDiseases/TyphoidFever',
  'suc-khoe-nam-gioi': 'MensHealth',
  'suc-khoe-nam-gioi/van-de-hormone-nam-gioi': 'MensHealth/HormoneIssues',
  'suc-khoe-nam-gioi/roi-loan-cuong-duong': 'MensHealth/ErectileDisfunction',
  'suc-khoe-nam-gioi/cong-duong-vat': 'MensHealth/PeyroniesDisease',
  'suc-khoe-nam-gioi/van-de-suc-khoe-nam-gioi-khac': 'MensHealth/HealthIssues',
  'suc-khoe-nam-gioi/suc-khoe-duong-vat': 'MensHealth/PenisHealth',
  'suc-khoe-rang-mieng': 'OralHealth',
  'suc-khoe-rang-mieng/cham-soc-rang-mieng': 'OralHealth/OralCare',
  'suc-khoe-rang-mieng/viem-nuou-nha-chu': 'OralHealth/GumMouth',
  'suc-khoe-rang-mieng/van-de-ve-rang': 'OralHealth/DentalConditions',
  'suc-khoe-rang-mieng/nha-khoa-tham-my': 'OralHealth/CosmeticDentistry',
  'suc-khoe-rang-mieng/chinh-nha': 'OralHealth/Orthodontics',
  'suc-khoe-rang-mieng/nha-khoa-nhi': 'OralHealth/PediatricDentistry',
  'suc-khoe-rang-mieng/van-de-rang-mieng-khac':
    'OralHealth/OtherOralHealthIssues',
  'benh-co-xuong-khop': 'Musculoskeletal',
  'benh-co-xuong-khop/viem-khop': 'Musculoskeletal/Arthritis',
  'benh-co-xuong-khop/loang-xuong': 'Musculoskeletal/Osteoporosis',
  'benh-co-xuong-khop/chan-thuong-chinh-hinh':
    'Musculoskeletal/OrthopedicSurgery',
  'benh-co-xuong-khop/ran-xuong-gay-xuong':
    'Musculoskeletal/FracturesBrokenBones',
  'benh-co-xuong-khop/dau-co-xuong-khop': 'Musculoskeletal/MusculoskeletalPain',
  'benh-co-xuong-khop/van-de-khop-day-chang-khac':
    'Musculoskeletal/OtherJointTendonDiseases',
  'benh-co-xuong-khop/van-de-xuong-khac': 'Musculoskeletal/OtherBoneDiseases',
  'nuoi-day-con': 'parenting',
  'nuoi-day-con/be-0-1-tuoi': 'parenting/Baby',
  'nuoi-day-con/be-0-1-tuoi/dinh-duong-cho-tre': 'parenting/Baby/BabyNutrition',
  'nuoi-day-con/be-0-1-tuoi/nam-dau-doi-cua-be':
    'parenting/Baby/BabysFirstYear',
  'nuoi-day-con/be-0-1-tuoi/nuoi-con-bang-sua-me':
    'parenting/Baby/Breastfeeding',
  'nuoi-day-con/be-0-1-tuoi/cham-soc-be': 'parenting/Baby/BabyCare',
  'nuoi-day-con/be-0-1-tuoi/tre-sinh-non': 'parenting/Baby/PrematureBabies',
  'nuoi-day-con/tre-1-5-tuoi': 'parenting/ToddlerPreschooler',
  'nuoi-day-con/tre-1-5-tuoi/cot-moc-1-5-tuoi':
    'parenting/ToddlerPreschooler/Milestones',
  'nuoi-day-con/tre-1-5-tuoi/su-phat-trien-tre-1-5-tuoi':
    'parenting/ToddlerPreschooler/GrowthDevelopment',
  'nuoi-day-con/tre-1-5-tuoi/dinh-duong-cho-tre-1-5-tuoi':
    'parenting/ToddlerPreschooler/Nutrition',
  'nuoi-day-con/tre-di-hoc': 'parenting/SchoolAgeChildren',
  'nuoi-day-con/tre-di-hoc/cot-moc-tre-di-hoc':
    'parenting/SchoolAgeChildren/Milestones',
  'nuoi-day-con/tre-di-hoc/su-phat-trien-tre-di-hoc':
    'parenting/SchoolAgeChildren/GrowthDevelopment',
  'nuoi-day-con/tre-di-hoc/dinh-duong-tre-di-hoc':
    'parenting/SchoolAgeChildren/Nutrition',
  'nuoi-day-con/nhi-khoa': 'parenting/ChildHealth',
  'nuoi-day-con/nhi-khoa/tiem-phong-cho-tre': 'parenting/ChildHealth/Vaccines',
  'nuoi-day-con/nhi-khoa/trieu-chung-thuong-gap-tre-em':
    'parenting/ChildHealth/CommonSymptoms',
  'nuoi-day-con/nhi-khoa/benh-truyen-nhiem-tre-em':
    'parenting/ChildHealth/InfectiousDiseases',
  'nuoi-day-con/nhi-khoa/suy-dinh-duong-tre-em':
    'parenting/ChildHealth/Malnutrition',
  'nuoi-day-con/nhi-khoa/roi-loan-hanh-vi-phat-trien':
    'parenting/ChildHealth/BehavioralDevelopmentalDisorders',
  'nuoi-day-con/nhi-khoa/van-de-than-kinh-tre-em':
    'parenting/ChildHealth/NeurologicalDiseases',
  'nuoi-day-con/nhi-khoa/van-de-tieu-hoa-tre-em':
    'parenting/ChildHealth/DigestiveProblems',
  'nuoi-day-con/nhi-khoa/van-de-da-tre-em':
    'parenting/ChildHealth/SkinDiseases',
  'nuoi-day-con/nhi-khoa/van-de-ho-hap-tre-em':
    'parenting/ChildHealth/RespiratoryDiseases',
  'nuoi-day-con/nhi-khoa/van-de-nhi-khoa-khac':
    'parenting/ChildHealth/OtherChildHealthIssues',
  'nuoi-day-con/tuoi-day-thi': 'parenting/Adolescents',
  'nuoi-day-con/tuoi-day-thi/cot-moc-tuoi-day-thi':
    'parenting/Adolescents/MilestonesDevelopment',
  'nuoi-day-con/tuoi-day-thi/tam-ly-tuoi-day-thi':
    'parenting/Adolescents/MentalHealth',
  'nuoi-day-con/tuoi-day-thi/suc-khoe-tuoi-day-thi':
    'parenting/Adolescents/Health',
  'mang-thai': 'pregnancy',
  'mang-thai/chuan-bi-mang-thai': 'pregnancy/GettingPregnant',
  'mang-thai/chuan-bi-mang-thai/hiem-muon-vo-sinh':
    'pregnancy/GettingPregnant/FertilityProblemsTreatment',
  'mang-thai/chuan-bi-mang-thai/kinh-nghiem-thu-thai':
    'pregnancy/GettingPregnant/RealStories',
  'mang-thai/chuan-bi-mang-thai/chu-de-thu-thai-khac':
    'pregnancy/GettingPregnant/OtherConceptionTopics',
  'mang-thai/chuan-bi-mang-thai/chuan-bi-tien-san':
    'pregnancy/GettingPregnant/PregnantPreparation',
  'mang-thai/thai-ky': 'pregnancy/BeingPregnant',
  'mang-thai/thai-ky/cham-soc-me-bau': 'pregnancy/BeingPregnant/PrenatalCare',
  'mang-thai/thai-ky/tam-ca-nguyet-1': 'pregnancy/BeingPregnant/FirstTrimester',
  'mang-thai/thai-ky/tam-ca-nguyet-2':
    'pregnancy/BeingPregnant/SecondTrimester',
  'mang-thai/thai-ky/tam-ca-nguyet-3': 'pregnancy/BeingPregnant/ThirdTrimester',
  'mang-thai/thai-ky/suc-khoe-khi-mang-thai':
    'pregnancy/BeingPregnant/pregnancyProblems',
  'mang-thai/thai-ky/cau-chuyen-me-bau': 'pregnancy/BeingPregnant/MyStory',
  'mang-thai/di-sinh': 'pregnancy/GivingBirth',
  'mang-thai/di-sinh/chuan-bi-di-sinh': 'pregnancy/GivingBirth/Preparing',
  'mang-thai/di-sinh/chuyen-da-sinh-no': 'pregnancy/GivingBirth/LaborDelivery',
  'mang-thai/di-sinh/bien-chung-khi-sinh':
    'pregnancy/GivingBirth/Complications',
  'mang-thai/di-sinh/kinh-nghiem-di-sinh': 'pregnancy/GivingBirth/BirthStories',
  'mang-thai/cham-soc-me-sau-sinh': 'pregnancy/MotherCare',
  'mang-thai/cham-soc-me-sau-sinh/hau-san':
    'pregnancy/MotherCare/PostpartumPeriod',
  'mang-thai/cham-soc-me-sau-sinh/khoe-dep-sau-sinh':
    'pregnancy/MotherCare/PostpartumSelfcare',
  'mang-thai/cham-soc-me-sau-sinh/tam-ly-sau-sinh':
    'pregnancy/MotherCare/MentalHealth',
  'mang-thai/cham-soc-me-sau-sinh/kinh-nghiem-sau-sinh':
    'pregnancy/MotherCare/WomansVoice',
  'mang-thai/cham-soc-me-sau-sinh/chu-de-sau-sinh-khac':
    'pregnancy/MotherCare/OtherMothercareTopics',
  'ho-va-benh-duong-ho-hap': 'respiratoryhealth',
  'ho-va-benh-duong-ho-hap/hen-suyen': 'respiratoryhealth/Asthma',
  'ho-va-benh-duong-ho-hap/viem-phe-quan-man-tinh':
    'respiratoryhealth/ChronicBronchitis',
  'ho-va-benh-duong-ho-hap/khi-phe-thung': 'respiratoryhealth/Emphysema',
  'ho-va-benh-duong-ho-hap/gian-phe-quan': 'respiratoryhealth/Bronchiectasis',
  'ho-va-benh-duong-ho-hap/benh-cum': 'respiratoryhealth/Influenza',
  'ho-va-benh-duong-ho-hap/benh-lao': 'respiratoryhealth/Tuberculosis',
  'ho-va-benh-duong-ho-hap/viem-phoi': 'respiratoryhealth/Pneumonia',
  'ho-va-benh-duong-ho-hap/u-hat-phoi': 'respiratoryhealth/Lung',
  'ho-va-benh-duong-ho-hap/cam-lanh': 'respiratoryhealth/Cold',
  'ho-va-benh-duong-ho-hap/viem-phe-quan': 'respiratoryhealth/Bronchitis',
  'ho-va-benh-duong-ho-hap/thuyen-tac-phoi':
    'respiratoryhealth/PulmonaryEmbolism',
  'ho-va-benh-duong-ho-hap/cac-van-de-ho-hap-khac':
    'respiratoryhealth/OtherRespiratoryIssues',
  'suc-khoe-tinh-duc': 'SexualWellness',
  'suc-khoe-tinh-duc/hiv-aids': 'SexualWellness/HIVAIDS',
  'suc-khoe-tinh-duc/ngua-thai': 'SexualWellness/Contraception',
  'suc-khoe-tinh-duc/tinh-duc-an-toan': 'SexualWellness/SafeSex',
  'suc-khoe-tinh-duc/benh-chlamydia': 'SexualWellness/Chlamydia',
  'suc-khoe-tinh-duc/benh-giang-mai': 'SexualWellness/Syphilis',
  'suc-khoe-tinh-duc/benh-lau': 'SexualWellness/Gonorrhea',
  'suc-khoe-tinh-duc/mun-rop-sinh-duc': 'SexualWellness/GenitalHerpes',
  'suc-khoe-tinh-duc/hpv': 'SexualWellness/HPV',
  'suc-khoe-tinh-duc/benh-trichomonas': 'SexualWellness/Trichomonas',
  'suc-khoe-tinh-duc/benh-tinh-duc-khac': 'SexualWellness/STIsSTDs',
  'suc-khoe-tinh-duc/bi-quyet-quan-he': 'SexualWellness/SexTips',
  'da-lieu': 'SkinHealth',
  'da-lieu/cham-soc-da': 'SkinHealth/SkinCareCleansing',
  'da-lieu/tri-mun': 'SkinHealth/Acne',
  'da-lieu/cham-soc-mong': 'SkinHealth/NailCare',
  'da-lieu/cham-soc-toc-da-dau': 'SkinHealth/HairScalpCare',
  'da-lieu/nhiem-trung-da': 'SkinHealth/InfectiousSkin',
  'da-lieu/vay-nen': 'SkinHealth/Psoriasis',
  'da-lieu/viem-da': 'SkinHealth/Dermatitis',
  'da-lieu/van-de-ve-da': 'SkinHealth/OtherSkinDiseases',
  'benh-than-va-duong-tiet-nieu': 'UrologicalHealth',
  'benh-than-va-duong-tiet-nieu/benh-than': 'UrologicalHealth/KidneyDisease',
  'benh-than-va-duong-tiet-nieu/benh-bang-quang':
    'UrologicalHealth/BladderProblems',
  'benh-than-va-duong-tiet-nieu/soi-duong-tiet-nieu':
    'UrologicalHealth/UrinaryTrackStones',
  'benh-than-va-duong-tiet-nieu/tieu-khong-tu-chu':
    'UrologicalHealth/UrinaryIncontinence',
  'benh-than-va-duong-tiet-nieu/nhiem-trung-duong-tieu': 'UrologicalHealth/UTI',
  'benh-than-va-duong-tiet-nieu/van-de-tiet-nieu-khac':
    'UrologicalHealth/OtherUrologicalIssues',
  'benh-than-va-duong-tiet-nieu/tuyen-tien-liet':
    'UrologicalHealth/ProstateHealth',
  'suc-khoe-phu-nu': 'womenshealth',
  'suc-khoe-phu-nu/u-xo-tu-cung': 'womenshealth/MyomaCysts',
  'suc-khoe-phu-nu/benh-tuyen-giap': 'womenshealth/FemaleHormonalImbalance',
  'suc-khoe-phu-nu/buong-trung-da-nang': 'womenshealth/PCOS',
  'suc-khoe-phu-nu/viem-am-dao': 'womenshealth/Vaginitis',
  'suc-khoe-phu-nu/van-de-vung-chau': 'womenshealth/PelvicRelatedIssue',
  'suc-khoe-phu-nu/man-kinh': 'womenshealth/Menopause',
  'suc-khoe-phu-nu/sang-loc-kiem-tra-phu-khoa': 'womenshealth/ScreeningTests',
  'suc-khoe-phu-nu/chu-ky-kinh-nguyet': 'womenshealth/Menstruation',
  'suc-khoe-phu-nu/van-de-phu-khoa-khac': 'womenshealth/womenshealthIssue',
  uncategorized: '',
  'kiem-tra-suc-khoe': 'HealthTools',
  'kiem-tra-suc-khoe/cach-tinh-chi-so-bmi': 'HealthTools/BMI',
  'kiem-tra-suc-khoe/tinh-chi-so-bmr': 'HealthTools/BMR',
  'kiem-tra-suc-khoe/tinh-ngay-rung-trung': 'HealthTools/OvulationCalculator',
  'kiem-tra-suc-khoe/cach-tinh-nhip-tim-muc-tieu': 'HealthTools/HeartRate',
  'kiem-tra-suc-khoe/cach-tinh-nong-do-con-trong-mau-bac': 'HealthTools/BAC',
  'kiem-tra-suc-khoe/cong-cu-tinh-chi-phi-hut-thuoc-la':
    'HealthTools/SmokingCostCalculator',
  'kiem-tra-suc-khoe/phan-tre-so-sinh-nhu-the-nao-la-tot':
    'HealthTools/BabysFeces',
  'kiem-tra-suc-khoe/cong-cu-tinh-can-nang-khi-mang-thai':
    'HealthTools/PregnancyWeight',
  'kiem-tra-suc-khoe/ty-le-dot-chay-calo': 'HealthTools/CaloriesCalculator',
  'kiem-tra-suc-khoe/cong-cu-tinh-ngay-du-sinh':
    'HealthTools/BirthDateCalculator',
  'kiem-tra-suc-khoe/lich-tiem-chung': 'HealthTools/ImmunizationSchedule',
  'kiem-tra-suc-khoe/ket-qua-lich-tiem-chung':
    'HealthTools/ImmunizationReminder',
  // END TRIM MARKER
}

export const spotlightViVN: {
  [k: string]: string
} = {
  // START TRIM MARKER
  'tang-cuong-suc-khoe-duong-ruot': 'Spotlight/GutHealth',
  'roi-loan-nhan-thuc-va-suc-khoe-nao-bo': 'Spotlight/MemoryDecline',
  'suc-khoe-covid-19': 'Spotlight/Covid19Fact',
  'tuan-le-glocom-the-gioi': 'Spotlight/Glaucoma',
  'vi-suc-khoe-phu-nu': 'Spotlight/WomensHealth',
  'ngay-the-gioi-phong-chong-ung-thu': 'Spotlight/Cancer',
  'hieu-ve-bao-hiem-quan-ly-rui-ro-bao-ve-ban-than-va-gia-dinh':
    'Spotlight/Insurance',
  '2022-chon-khoe': 'Spotlight/NewNormal',
  'thang-nang-cao-nhan-thuc-ve-sinh-mo': 'Spotlight/Caesarean',
  'tuan-le-tiem-chung-the-gioi': 'Spotlight/Vaccinations',
  // END TRIM MARKER
}
